export const stripe = {
  subTitle:
    "Vincula tu cuenta de Stripe para poder cobrar el monto de la reserva a tus clientes de una forma rápida y sencilla, evitando las comisiones de las Agencias de viajes en línea.",
};
